var angular = require('angular')
var contentService = require('aem-libs-angularjs/src/services/content.service.js').contentService
require('aem-libs-angularjs/src/components/wcm-html-content/wcm-html-content.component.js')
var isObjectName = require('../../services/isObjectName')

angular.module('WcmObjectCmp', ['WcmHtmlContentCmp'])
  .factory('contentService', contentService)
  .component('wcmObject', {
    template: require('./wcm-object.component.tpl.html'),
    controller: WcmObjectCtrl,
    controllerAs: 'vm',
    bindings: {
      objectName: '<',
      objectContentRf: '@'
    }
  })

WcmObjectCtrl.$inject = ['contentService']

function WcmObjectCtrl (contentService) {
  var vm = this

  vm.$onInit = function () {
    vm.fileContent = null

    if (isObjectName(vm.objectName)) {
      contentService.getStaticHtml('internet', vm.objectName).promise
        .then(function (res) {
          vm.fileContent = res.data
        })
    }
  }
}
